export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class EnvironmentVariablesError extends Error {
  constructor(
    message: string = 'Отсутствует конфигурация сервера. Пожалуйста, проверьте переменные окружения.'
  ) {
    super(message);
    this.name = 'EnvironmentVariablesError';
  }
}

export class InvalidDataError extends Error {
  constructor(message: string = 'Некорректныый формат данных') {
    super(message);
    this.name = 'InvalidDataError';
  }
}

export class HMACError extends Error {
  constructor(message: string = 'Нарушена целостность данных') {
    super(message);
    this.name = 'HMACError';
  }
}
export class GenerateMetadataError extends Error {
  constructor(message: string = 'Ошибка при получении метаданных') {
    super(message);
    this.name = 'GenerateMetadataError';
  }
}
export class ServerError extends Error {
  constructor(message: string = 'Неизвестная ошибка сервера') {
    super(message);
    this.name = 'ServerError';
  }
}

export class IncompleteDataError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'IncompleteDataError';
  }
}
